import { gql, type OperationVariables } from '@apollo/client';
import type ICompanySettings from '@sharedInterfaces/ICompanySettings';
import Company from '@src/Objects/Company';
import { companySettingsGql } from '../Company/getCompanySettings';
import GraphQL from '../graphQL';

const query = gql`
mutation setOUAdGroup($id: Int!, $adGroupId: String) {
    setOUAdGroup(id: $id, adGroupId: $adGroupId)
    ${companySettingsGql}
},
`;

export default async function setOUAdGroup(id: number, adGroupId: string | null) {
    const variables: OperationVariables = { id, adGroupId };
    return GraphQL.mutate<ICompanySettings>(query, variables).then((obj) => new Company(obj));
}
